import type { Theme } from '@mui/material';

export const muiListItemOverrides = {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => {
			return {
				paddingTop: 0,
				paddingLeft: theme.tsGoUnit.tsUnitQuarter,
				paddingBottom: theme.tsGoUnit.tsUnitHalf,
				fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
				color: theme.palette.tsGoColor.black,
			};
		},
	},
};
